/**
 * K线图鲸奇9转装饰器
 */
import {mergeModelData} from '../../../util/index.js';
const model = {
  jqRiseList: {
    Type: Array,
    Default: () => ([])
  },
  jqFallList: {
    Type: Array,
    Default: () => ([])
  }
};
const KLineJQJZDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {jqRiseList, jqFallList, start, end, kline} = this.state.data;
    const {height} = this.availArea;
    const baseSize = this.state.baseSize;
    const {
      sizeRatio,
      fontFamily,
    } = this.option.JQJZ;
    const {
      jqHeight,
      triangleWidth,
      verticalSpace,
    } = this.measureJQJZLabel({
      text: '9',
      fontSize: sizeRatio * baseSize * this.dpr,
      fontFamily
    });
    let _max = this.maxValue;
    let _min = this.minValue;
    let _tempMax = _max;
    let _tempMin = _min;
    const _c = (verticalSpace + jqHeight + triangleWidth * 2) / height;
    const _rate = (this.maxValue - this.minValue) * _c;
    jqRiseList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const val = kline[item.index].low_px - _rate;
      if (val < _tempMin) {
        _tempMin = val;
        _min = kline[item.index].low_px;
      }
    });
    jqFallList.filter(a => a.index >= start && a.index < end).forEach(item => {
      const val = kline[item.index].high_px + _rate;
      if (val > _tempMax) {
        _tempMax = val;
        _max = kline[item.index].high_px;
      }
    });
    if (_tempMax !== this.maxValue && _tempMin !== this.minValue) {
      this.maxValue = (_max - _min * _c - _max * _c) / (1 - 2 * _c);
      this.minValue = (_min - _max * _c - _min * _c) / (1 - 2 * _c);
    } else if (_tempMax !== this.maxValue) {
      this.maxValue = (_max - _min * _c) / (1 - _c);
    } else if (_tempMin !== this.minValue) {
      this.minValue = (_min - _max * _c) / (1 - _c);
    }
    this.baseValue = (this.maxValue + this.minValue) / 2;
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      bottom,
      width
    } = this.availArea;
    const {kline} = this.state.data;
    this._drawJQJZ(kline, left, bottom, width);
  }
}

export default KLineJQJZDectorator;